import { capitalize } from '../string';

export const formatMoonIllumination = (moonIllumination: string | undefined): string => {
  if (moonIllumination) {
    return capitalize(moonIllumination.replace('_', ' '));
  }
  return '';
};
